import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .RVFilterAndListContainer': {
    position: 'relative',
    paddingTop: theme.typography.pxToRem(64),
    [theme.breakpoints.down('lg')]: {
      paddingTop: theme.typography.pxToRem(40),
    },
    '& .RVBGPattern': {
      position: 'absolute',
      top: 0,
      width: '100%',
      height: theme.typography.pxToRem(205),
      zIndex: 1,
      filter: 'brightness(0.7) contrast(2)',
    },
  },

  '& .RVCustomContainer': {
    position: 'relative',
    zIndex: 2,
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    [theme.breakpoints.down('lg')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
}));

export default StyledBox;
